export const fallbackCourses = [
  {
    id: 31,
    title: '《轻松做外贸·0-1全流程》',
    images: 'https://img.longmeika.com/365_hg/image/202608090136117fne',
    lights: '从客户开发、询盘跟进到物流报关，系统掌握外贸成交全流程。',
    price: 299,
    freeType: 2,
    teacherName: '刘真'
  },
  {
    id: 30,
    title: '不是教你玩AI：子龙外贸思维智能体实战课',
    images: 'https://img.longmeika.com/365_hg/image/20260602221027eg0g',
    lights: '把 AI 真正用到国际站运营、询盘分析和客户跟进。',
    price: 1288,
    freeType: 2,
    teacherName: '徐子龙'
  }
]

export const fallbackCategories = [
  '阿里国际站', '国际贸易', 'Shopify', '图片设计', '手机软件', '速卖通', 'WhatsApp', 'AI与数字人'
]

export const teacherFallback = [
  { id: 1, name: '刘真', specialty: '外贸实战与全流程成交', initials: 'LZ' },
  { id: 2, name: '徐子龙', specialty: '国际站运营与AI实战', initials: 'XZL' },
  { id: 3, name: 'Kevin / 稳哥', specialty: '外贸咨询与业务增长', initials: 'KW' }
]
